import { render, staticRenderFns } from "./Seeds.vue?vue&type=template&id=012a5bf4&"
import script from "./Seeds.vue?vue&type=script&lang=ts&"
export * from "./Seeds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports